import moment from 'moment';
moment.locale('zh-cn');
const Heading = ({date, changeMonth, resetDate}) => (
  <nav className="calendar--nav">
    <a onClick={() => changeMonth(date.month() - 1)}>&#8249;</a>
    <h1 onClick={() => resetDate()}>{} <small>{date.format('YYYY') + '年' + date.format('M') + '月'}</small></h1>
    <a onClick={() => changeMonth(date.month() + 1)}>&#8250;</a>
  </nav>
);

const Day = ({currentDate, date, startDate, endDate, onClick}) => {

  let className = [];

  if (moment().isSame(date, 'day')) {
    className.push('active');
  }

  if (startDate && date.isSame(startDate, 'day')) {
    className.push('start');
  }

  if (startDate && endDate && date.isBetween(startDate, endDate, 'day')) {
    className.push('between');
  }

  if (endDate && date.isSame(endDate, 'day')) {
    className.push('end');
  }

  if (! date.isSame(currentDate, 'month')) {
    className.push('muted');
  }

  return (
    <span onClick={() => onClick(date)} className={className.join(' ')}>{date.date()}</span>
  )
};

const Days = ({date, startDate, endDate, onClick}) => {
  console.log('startDate=====',startDate);
  console.log('endDate=====',endDate);
  const thisDate = moment(date);
  const daysInMonth = moment(date).daysInMonth();
  const firstDayDate = moment(date).startOf('month');
  const previousMonth = moment(date).subtract(1, 'month');
  const previousMonthDays = previousMonth.daysInMonth();
  const nextsMonth = moment(date).add(1, 'month');
  let days = [];
  let labels = [];

  for (let i = 1; i <= 7; i++) {
    labels.push(<span key={`Calendar_days_span_${i}`} className="label">{moment().day(i).format('ddd')}</span>);
  }

  for (let i = firstDayDate.day() || 7; i > 1; i--) {
    previousMonth.date(previousMonthDays - i + 2);

    days.push(
      <Day key={moment(previousMonth).format('DD MM YYYY')} onClick={(date) => onClick(date)} currentDate={date} date={moment(previousMonth)} startDate={startDate} endDate={endDate} />
    );
  }

  for (let i = 1; i <= daysInMonth; i++) {
    thisDate.date(i);

    days.push(
      <Day key={moment(thisDate).format('DD MM YYYY')} onClick={(date) => onClick(date)} currentDate={date} date={moment(thisDate)} startDate={startDate} endDate={endDate} />
    );
  }

  const daysCount = days.length;
  for (let i = 1; i <= (42 - daysCount); i++) {
    nextsMonth.date(i);
    days.push(
      <Day key={moment(nextsMonth).format('DD MM YYYY')} onClick={(date) => onClick(date)} currentDate={date} date={moment(nextsMonth)} startDate={startDate} endDate={endDate} />
    );
  }

  return (
    <nav className="calendar--days">
      {labels.concat()}
      {days.concat()}
    </nav>
  );
};

import './Calendar.less';

import React, {PropTypes,Component}  from 'react';
import tools from '../../utils/tools';

class Calendar extends Component {

  // static propTypes = {
  //   startDate: React.PropTypes.string,
  //   endDate: React.PropTypes.string,
  //   dateClick: React.PropTypes.func
  // };
  constructor(props) {
    super(props);
    const {startDate,endDate} = this.props;
    let state_startDate,state_endDate;
    if(startDate){
       state_startDate = moment(startDate, "YYYY-MM-DD");
    }
    if(endDate){
       state_endDate = moment(endDate, "YYYY-MM-DD");
    }

    this.state = {
      date: moment(),
      startDate:state_startDate,
      endDate:state_endDate
    };
  }

  resetDate() {
    console.log('reset....');
    this.setState({
      date: moment()
    });
  }

  changeMonth(month) {
    const {date} = this.state;
    date.month(month);
    this.needRender = true;
    this.setState(
      date
    );


  }

  shouldComponentUpdate(nextProps, nextState) {
    if(this.props.startDate == nextProps.startDate && this.props.endDate == nextProps.endDate){
        if(true == this.needRender){
          this.needRender = false;
          return true;
        }
        return false;
    }
    return true;
  }

  changeDate(date) {
    //设置开始 结束时间
    let {startDate, endDate} = this.state;

    //如果startDate和endDate都有值  再次点击  当重置处理
    //如果目前startDate，endDate 都为空||date before startDate  此date为开始日期
    if((startDate && endDate)||!startDate){
      startDate = moment(date);
      endDate = undefined;
    }else{
      if(startDate && date.isBefore(startDate, 'day')){
        startDate = moment(date);
        endDate = undefined;
      }else{
        endDate = moment(date);
      }
    }


    // console.log('date============',date);
    //
    //

    // if (startDate === null || date.isBefore(startDate, 'day') || ! startDate.isSame(endDate, 'day')) {
    //   startDate = moment(date);
    //   endDate = moment(date);
    // } else if (date.isSame(startDate, 'day') && date.isSame(endDate, 'day')) {
    //   startDate = null;
    //   endDate = null;
    // } else if (date.isAfter(startDate, 'day')) {
    //   endDate = moment(date);
    // }
    this.setState({
      startDate,
      endDate
    });


    let sDate = '',eDate ='';
    if(startDate){
      sDate = moment(startDate).format('YYYY-MM-DD');
    }
    if(endDate){
      eDate = moment(endDate).format('YYYY-MM-DD');
    }
    this.props.dateClick && this.props.dateClick(sDate, eDate);
  }

  render() {
    const {date, startDate, endDate} = this.state;
    return (
      <div className="calendar">
        <Heading date={date} changeMonth={(month) => this.changeMonth(month)} resetDate={() => this.resetDate()} />
        <Days onClick={(date) => this.changeDate(date)} date={date} startDate={startDate} endDate={endDate} />
      </div>
    );
  }
}

export default Calendar;
